import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, Link } from 'react-router-dom';
import { Spin, Button, Menu, Dropdown } from 'antd';
import {
  MailOutlined,
  SettingOutlined,
  // AlertOutlined,
  UserOutlined,
  LogoutOutlined,
} from '@ant-design/icons';

import Client from 'containers/app/client';
import { getRoutePrefix } from 'utils/routes';
import { useUserWithRole } from 'hooks/custom-auth';

import NotificationBadge from '../notification-badge';

const User = ({ userType }) => {
  const history = useHistory();
  const [user, loading, error] = useUserWithRole(Client.auth);

  if (loading) return <Spin />;
  if (error) throw error;

  if (!user)
    return (
      <>
        {/* check if a user type is set */}
        {userType !== '' && (
          <Button type="primary">
            <Link to={`/login/${userType}`}>Login</Link>
          </Button>
        )}
      </>
    );

  const { displayName } = user;

  const handleButtonClick = (e) => {
    e.preventDefault();
    history.push(`${getRoutePrefix(user.claims.role)}/dashboard`);
  };

  const menu = (
    <Menu>
      <Menu.Item
        onClick={() => {
          history.push('/profile');
        }}
      >
        <MailOutlined />
        Profile
      </Menu.Item>

      <Menu.Item
        onClick={() => {
          history.push('/change-password');
        }}
      >
        <SettingOutlined />
        Update password
      </Menu.Item>
      {/* <Menu.Item
        onClick={() => {
          history.push('/debug');
        }}
      >
        <AlertOutlined />
        Debug
      </Menu.Item> */}
      <Menu.Item
        onClick={() => {
          Client.auth.signOut();
          window.location = "http://my-shifts.co.uk";
        }}
      >
        <LogoutOutlined />
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Dropdown.Button
        overlay={menu}
        icon={<UserOutlined />}
        onClick={handleButtonClick}
      >
        <NotificationBadge role={user.claims.role} />
        {displayName}
      </Dropdown.Button>
    </>
  );
};

User.propTypes = {
  userType: PropTypes.string,
};

User.defaultProps = {
  userType: '',
};

export default User;
